import { environment } from "./env";
import { toaster } from "./toaster";

export function fuzzyMatch(source: string, target: string) {
  const sourceLower = source.toLowerCase().replace(/\s+/g, "");
  const targetLower = target.toLowerCase().replace(/\s+/g, "");
  let targetIdx = 0;
  let matchCount = 0;

  for (let i = 0; i < sourceLower.length && targetIdx < targetLower.length; i++) {
    if (sourceLower[i] === targetLower[targetIdx]) {
      matchCount++;
      targetIdx++;
    }
  }
  return matchCount >= targetLower.length;
}

export function isArrayEqual(a: string | any[], b: string | any[]) {
  if (a.length !== b.length) return false;
  const sortedA = [...a].sort();
  const sortedB = [...b].sort();

  for (let i = 0; i < sortedA.length; i++) {
    if (sortedA[i] !== sortedB[i]) return false;
  }

  return true;
}

export function copyToClipboard(text: string, description: string = "") {
  navigator.clipboard.writeText(text);
  toaster.success("Copied to clipboard", description);
}

export async function pasteFromClipboard() {
  const text = await navigator.clipboard.readText();

  return text;
}

export function saveToast(title: string, description: string = "") {
  toaster.success(title, description);
}

export const applyTheme = (selectedMode: string) => {
  if (
    selectedMode === "light" ||
    (selectedMode === "system" && window.matchMedia && window.matchMedia("(prefers-color-scheme: light)").matches)
  ) {
    document.body.classList.remove("dark");
  } else if (
    selectedMode === "dark" ||
    (selectedMode === "system" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches)
  ) {
    document.body.classList.add("dark");
  }
};

export const isRedactiveUser = async (email: string) => {
  const domainList = (await environment).adminEmails ?? [];
  return domainList.some((domain) => email.endsWith(`@${domain}`));
};
